import Swal from "sweetalert2";
import scssVars from '../../../styles/vars.scss';

function errorMsg(text = "Something went wrong!") {
    return Swal.fire({
        icon: "error",
        title: "Oops...",
        text,
        zIndex: 10000
      });
}

function deletedMsg() {
    return Swal.fire({
        title: "Deleted!",
        text: "Your file has been deleted.",
        icon: "success",
        zIndex: 10000
      });
}

function confirmMsg() {
    return Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: scssVars.blue,
        cancelButtonColor: scssVars.red,
        confirmButtonText: "Yes!",
        zIndex: 10000
      });
}

function savedMsg(title = 'Your work has been saved', extra) {
    if(extra){
        title += `\n${extra}`
    }
    return Swal.fire({
        position: 'center',
        icon: 'success',
        title,
        showConfirmButton: false,
        timer: 1500,
        zIndex: 10000
      })
}

function confirmReplaceDeviceCode({ title, text, confirmButtonText = 'OK', cancelButtonText = 'Cancel' }) {
	return Swal.fire({
		title,
		text,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText,
		cancelButtonText,
		zIndex: 10050,
	});
}

function confirmYesNo({ title, text, confirmButtonText = 'Yes', cancelButtonText = 'No', html }) {
	return Swal.fire({
		title,
		text: html ? undefined : text,
		html: html || undefined,
		icon: 'question',
		showCancelButton: true,
		confirmButtonColor: scssVars.blue,
		cancelButtonColor: scssVars.red,
		confirmButtonText,
		cancelButtonText,
		zIndex: 10000,
	})
}

/** Assignment issues dialog. Pass cancelButtonText to show Continue / Stay; omit for OK-only. */
function showAssignmentIssues({ title, html, confirmButtonText, cancelButtonText }) {
	return Swal.fire({
		title,
		html,
		icon: 'warning',
		showCancelButton: !!cancelButtonText,
		confirmButtonColor: scssVars.blue,
		cancelButtonColor: scssVars.red,
		confirmButtonText,
		cancelButtonText,
		zIndex: 10000,
	})
}

export default {
    errorMsg,
    confirmMsg,
    confirmReplaceDeviceCode,
    confirmYesNo,
    showAssignmentIssues,
    deletedMsg,
    savedMsg
}
